import React from 'react'
import { BlockProps } from 'antd/lib/typography/Base'
import { TextProps as AntTextProps } from 'antd/lib/typography/Text'
import { Typography } from 'antd'

import { T, Tstring } from 'src/components/atoms'

import { WrapSpan, WrapDot } from './style'

interface TextProps extends AntTextProps {
  prefix?: any
  suffix?: any
  text?: any
}

//Has not been exported by ANT in the current version
type TitleProps = Omit<
  BlockProps & {
    level?: 1 | 2 | 3 | 4
  },
  'strong'
> & { text?: string }

function Text({ children, prefix, suffix, text, ...restProps }: TextProps) {
  return (
    <Typography.Text {...restProps}>
      {prefix}
      {!children ? <T text={text} /> : children}
      {suffix}
    </Typography.Text>
  )
}

function TextTValue({
  children,
  dot = ': ',
  strong = true,
  suffix,
  text,
  ...restProps
}: TextProps & { dot?: string }) {
  return (
    <WrapSpan>
      <Text {...restProps} strong={strong} suffix={dot} text={text} />
      <WrapDot />
      {children}
      {suffix}
    </WrapSpan>
  )
}

function Title({ text, children, ...restProps }: TitleProps) {
  return (
    <Typography.Title {...restProps}>
      {!children ? Tstring(text) : children}
    </Typography.Title>
  )
}

export { Text, TextTValue, Title }
